import { useWindowSize } from '@vueuse/core';

export function useBreakpointHelper(breakpoint) {
  const { width, height } = useWindowSize();
  const screens = {
    'tw-sm': 375,
    'tw-md': 768,
    'tw-lg': 992,
    'tw-xl': 1200,
    'tw-2xl': 1275,
    'tw-3xl': 1440,
  };

  function isBelowCurrentBreakpoint(breakpoint) {
    if (!breakpoint) {
      breakpoint = 'tw-lg';
    }
    return width.value < screens[breakpoint];
  }

  return {
    windowWidth: width,
    windowHeight: height,
    isBelowCurrentBreakpoint,
  };
}
